// @flow
//eslint-disable-next-line

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { AppWrapper, CartActions } from '../../../../containers'
import {
	ARRAY_ROUTE_CONSTANTS,
	ANALYTICS_HELPER,
	CONSTANTS,
	PRODUCT_HELPER,
	HELPER,
	HISTORY,
	MANAGE_CART_HELPER,
} from '../../../../utils'
import { cartActions, metaAction } from '../../../../store/actions'
import { useTranslation } from '../../../../hooks'
import ProductAtrributes from './ProductAtrributes'

const MobileProductDetail = () => {
	let dispatch = useDispatch()
	const translate = useTranslation()

	const { cart_items, item_added } = useSelector((state) => state.cart)
	const { catalog_cart_items } = useSelector((state) => state.config.catalog_journey_settings)
	const { allProducts } = useSelector((state) => state.inventory)
	const { showProductDetail } = useSelector((state) => state.action)
	const { selected_product } = useSelector((state) => state.inventory)
	const { maximum_purchase_limit } = useSelector((state) => state.inventory.inventory_settings)
	const { selected_variant } = useSelector((state) => state.inventory.selected_product)
	const { items } = useSelector((state) => state.cart.cart_items)

	const ADD_TO_CART = () => {
		let itemAdded = true
		let itemFound = { qty: 1 }
		let res = items.find((item) => {
			return (
				item.product.id === selected_product.id &&
				item.product.selected_variant.variant_id === selected_product.selected_variant.variant_id
			)
		})
		if (HELPER.isNotEmpty(res)) {
			const total_amount = selected_variant.price * (res.qty + 1)
			itemAdded = MANAGE_CART_HELPER.AddCartRule(
				maximum_purchase_limit,
				selected_product.product_delivery_type,
				total_amount
			)
			if (itemAdded) {
				res.qty = res.qty + 1
				itemFound = res
			}
		}
		const max_quantity = PRODUCT_HELPER.PRODUCT_MAX_QUANTITY(selected_product)
		if (itemFound?.qty <= max_quantity && itemAdded && max_quantity > 0) {
			PRODUCT_HELPER.ADD_PRODUCT_TO_CART(selected_product, CONSTANTS.ADD_QTY, itemFound?.qty)
		} else if (itemFound?.qty > max_quantity && !HELPER.isEmpty(res) && max_quantity > 0) {
			res.qty = res.qty - 1
			itemFound = res
			MANAGE_CART_HELPER.MaxQuantityReached(selected_product)
		} else if (max_quantity <= 0) {
			MANAGE_CART_HELPER.outOfStock()
		}
		return true
	}

	useEffect(() => {
		ANALYTICS_HELPER._screenShift(
			ANALYTICS_HELPER.EVENT_STEPS.PRODUCT_DETAIL,
			ANALYTICS_HELPER.CATEGORY.PRODUCT_DETAIL
		)
		if (HELPER.isEmpty(selected_product?.id)) {
			HISTORY.goBack()
		}
		return () => {
			dispatch(metaAction.PRODUCT_DETAIL_SIDEBAR_OPEN())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		/*
          UPDATE CART ITEMS
        */
		if (HELPER.isEmpty(selected_product?.id)) {
			HISTORY.goBack()
		} else if (
			Object.keys(catalog_cart_items).length === 0 &&
			parseInt(cart_items.count) === 0 &&
			parseInt(cart_items?.sub_total_amount) === 0 &&
			ARRAY_ROUTE_CONSTANTS.includes(HISTORY.location.pathname) &&
			!HELPER.isEmpty(allProducts) &&
			!showProductDetail
		) {
			HISTORY.goBack()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cart_items, selected_product])

	useEffect(() => {
		if (!HELPER.isEmpty(item_added?.item) && showProductDetail) {
			dispatch(cartActions.CLEAR_ITEMS_IN_CART())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [item_added?.item])

	return (
		<AppWrapper
			showBackIcon={false}
			observeBackHistory={true}
			showLangIcon={true}
			showCartIcon={true}
			showAccountDropdown={true}
		>
			{HELPER.isNotEmpty(selected_product?.id) ? (
				<div className="productDetailMobileContent">
					<div className="productDetailMobileMenu">
						<div className={`closeProductMenu`}>
							<button onClick={() => HISTORY.goBack()}>
								<i className="icons-icon-back"></i>
							</button>
						</div>
						<div className="insidePrdMenuBox mobilePrdMenuBox">
							<div
								className="prdMenuImgBox"
								onClick={() => PRODUCT_HELPER.PRODUCT_SELECTION(selected_product)}
							>
								<div>
									<div className="prdMenuImg">
										<img
											src={PRODUCT_HELPER.PRODUCT_IMAGE(selected_product).src}
											alt={PRODUCT_HELPER.PRODUCT_IMAGE(selected_product).alt}
										/>
									</div>
								</div>
							</div>
							<div className="prodMenuDetailsWrap">
								<div className="prodName">
									<span>{PRODUCT_HELPER.FORMAT_PRODUCT_NAME(selected_product)}</span>
								</div>
								<div className="prodDescription">
									{PRODUCT_HELPER.DISPLAY_SHORT_DESCRIPTION(selected_product)}
								</div>
								<div className="prodAddNotes">
									{PRODUCT_HELPER.DISPLAY_ADDITIONAL_NOTES(selected_product)}
								</div>
							</div>
						</div>

						<ProductAtrributes selected_product={selected_product} />
					</div>
					<div className="productFooter" key={`productFooter-${selected_variant?.variant_id}`}>
						<div className="insideProductFooter">
							<div className="insideProductFooterContainer">
								<div className="cartPrdRight">
									<CartActions
										product={selected_product}
										key={`CartActions-${selected_variant?.variant_id}`}
									/>
								</div>
								<div className="cartPrdLeft">
									<div className="prodPrice suggestPrice strikeText">
										{PRODUCT_HELPER.FORMAT_PRICE(selected_product)}
									</div>
									<div className="prodPrice newPrice">
										{PRODUCT_HELPER.FORMAT_DISCOUNTED_PRICE(selected_product)}
									</div>
								</div>
							</div>
							<div className="insideProductFooterContainer">
								<button className="addedinCartBtn blueSubmitBtn" onClick={ADD_TO_CART}>
									{translate('CART.ADD_TO_CART')}
								</button>
								<button
									className="blueSubmitBtn"
									onClick={() => PRODUCT_HELPER.BUY_NOW(selected_product)}
								>
									{translate('CART.BUY_NOW')}
								</button>
							</div>
						</div>
					</div>
				</div>
			) : (
				''
			)}
		</AppWrapper>
	)
}

export default MobileProductDetail
